import { db } from '../config/firebase';
import { doc, writeBatch, increment, getDoc } from 'firebase/firestore';

interface Winner {
  userId: string;
  amount: number;
  claimed: boolean;
}

export const distributeRewards = async (drawId: string, winners: Winner[], totalAmount: number) => {
  try {
    const batch = writeBatch(db);
    const amountPerWinner = Math.floor(totalAmount / winners.length);

    // Mettre à jour le document du tirage avec les gagnants
    const drawRef = doc(db, 'draws', drawId);
    batch.update(drawRef, {
      status: 'completed',
      winners: winners.map(winner => ({
        ...winner,
        amount: amountPerWinner,
        claimed: false
      }))
    });

    // Réinitialiser les fonds collectifs
    const collectiveRef = doc(db, 'collectiveInvestment', 'current');
    batch.update(collectiveRef, {
      totalAmount: 0,
      participantsCount: 0,
      participants: [],
      lastUpdated: new Date()
    });

    await batch.commit();
  } catch (error) {
    console.error('Erreur lors de la distribution des récompenses:', error);
    throw error;
  }
};

export const claimReward = async (drawId: string, userId: string) => {
  try {
    const drawRef = doc(db, 'draws', drawId);
    const drawDoc = await getDoc(drawRef);
    const winners = drawDoc.data()?.winners || [] as Winner[];
    const winner = winners.find((w: Winner) => w.userId === userId);

    if (!winner) throw new Error('Winner not found');

    const batch = writeBatch(db);
    
    batch.update(drawRef, {
      'winners': winners.map((w: Winner) => 
        w.userId === userId ? { ...w, claimed: true } : w
      )
    });

    const walletRef = doc(db, 'wallets', userId);
    batch.update(walletRef, {
      balance: increment(winner.amount)
    });

    await batch.commit();
  } catch (error) {
    console.error('Erreur lors de la réclamation de la récompense:', error);
    throw error;
  }
}; 